import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Nav } from "./components/site/Nav";
import { Hero } from "./components/site/Hero";
import { Marquee } from "./components/site/Marquee";
import { About } from "./components/site/About";
import { HowItWorks } from "./components/site/HowItWorks";
import { Areas } from "./components/site/Areas";
import { Faq } from "./components/site/Faq";
import { Contact } from "./components/site/Contact";
import { WhatsFab } from "./components/site/WhatsFab";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    window.__lenis = lenis;
    let id;
    const raf = (t) => { lenis.raf(t); id = requestAnimationFrame(raf); };
    id = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(id); lenis.destroy(); window.__lenis = null; };
  }, []);

  return (
    <main className="bg-cream text-ink font-body overflow-x-clip">
      <Nav />
      <Hero />
      <Marquee />
      <About />
      <HowItWorks />
      <Areas />
      <Faq />
      <Contact />
      <WhatsFab />
    </main>
  );
}

export default App;
